export default __webpack_public_path__ + "static/media/partner_logo_boligmappa.7e681a69.svg";